import React from 'react';
import StoreTransferList, {StoreTransferListProps} from '../../../../components/StoreTransferList';

function StorePicker({handleStores, selectedStores}: StoreTransferListProps) {
  return <StoreTransferList handleStores={handleStores} selectedStores={selectedStores} />;
}

export default StorePicker;
